import store from "@/store";

export default async (to, from, next) => {
  console.log('wew');
  await store.dispatch("fetchPodcasts");
  next();
};
